var jQuery = require('jquery');
/**
 * Plugin se volá $('.pagination').universalPagination(props);
 * - upraví stránkování do ajaxové podoby
 * - umožní nekonečné načítání pomocí tlačítka "Více" včetně zachování a vylepšení číslovaného stránkování (ALZA style)
 * - pamatuje si poslední navštívenou stránku v HTML5 history a po návratu z detailu článku tuto poslední stránku načte
 *
 * - při infinite stránkování (button "Více") načte skript další stránku, naparsuje z ní pouze položky seznamu a ty přidá na konec již existujícího seznamu
 * - při kliknutí na číslované stránkování načte skript další stránku, naparsuje z ní pouze položky seznamu a ty přidá do již existujícího seznamu s tím, že předchozí položky smaže
 *
 * TODO
 * - ukládání navštívené stránky do URL (pushState), prozatím ukládáno přes replaceState
 */
(function($, window, document, undefined ) {

	"use strict";

	var PLUGIN_NAME = "universalPagination";
	var PLUGIN_VERSION = "v1.0";

	var	DEFAULTS = {
		// getter settings
		nextPageButtonSelector: 'a.next',	// identifikace prvku, který vede na další stránku. Použito pro "Více" button
		listSelector: '',					// identifikace celého seznamu první stránky, do kterého budou načítány další stránky
		itemSelector: 'li',					// identifikace jednoho prvku stránkovaného seznamu
		paginationSelector: '.pagination',	// temp proměnná, zpravidla stejná, jako selektor, na který se volá plugin.
											// Z nějakého důvodu už nefunguje načtení selektoru z jQuery objektu, vyřeším později

		// render settings
		wrapperClass: 'pagination-wrapper',	// objekt vytvořený pluginem, do tohoto divu bude zabalen existující pagination prvek a bude v něm vygenerován i "Více" button
		nextClass: '',						// className "Více" buttonu
		nextWrapperClass: '',				// className odstavce, který má v sobě "Více" button. Nechceme mít <A> samostatně bez dohledu blokového prvku
		infinitePagination: true,			// zapnutí "Více" buttonu
		numberedPagination: true,			// na klasické stránkování aplikuje ajaxový loading, obecně by nemělo být toto stránkování vypnuto a ponecháno pouze infinite, protože pak není cesta zpět na předchozí stránku
		enableAutoscroll: true,				// po odstránkování pomocí číslovaného stránkování automaticky provede scroll na první položku seznamu
		listTopOffset: 25,					// při odscrollování (viz řádek výše) se posune scrollbar o tuto hodnotu výše, než je první položka seznamu
		autoPreloadHistory: true,			// pokud je tato hodnota true, skript ukládá k aktuální položce v historii browseru poslední stránku seznamu a při návratu pomocí zpět tuto stránku opět načte

		// events
		onBeforeNewPageLoad: 'UP_BEFORE_PAGE_LOAD',
		onBeforePageContentRendered: 'UP_BEFORE_CONTENT_RENDERED',

		onAfterPagedContentRendered: 'UP_AFTER_CONTENT_RENDERED',		// název eventy, která je vystřelovaná okamžitě po vyrenderování nových položek do existujícího seznamu
		onAfterPageChanged: 'UP_AFTER_PAGE_CHANGED',					// název eventy, která je vystřelena po vyrenderování nového stránkování

		// i18n
		lang: 'en',
		messages: {
			cs: {
				next: 'Načíst další',
				loading: 'Nahrává se…'
			},
			sk: {
				next: 'Načítať ďalšie',
				loading: 'Nahráva sa…'
			},
			en: {
				next: 'Load more',
				loading: 'Loading…'
			},
			de: {
				next: 'Mehr',
				loading: 'Wird geladen…'
			},
			es: {
				next: 'Más',
				loading: 'Se está grabando…'
			},
			it: {
				next: 'Di più',
				loading: 'Sto caricando…'
			},
			ru: {
				next: 'Подробнее',
				loading: 'Скачивается'
			},
			ko: {
				next: '더 보기',
				loading: '로드 중입니다'
			},
			zh: {
				next: '更多',
				loading: '正在打开...'
			},
			ja: {
				next: '次へ',
				loading: '記録しています'
			}
		}
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	var UniversalPagination = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;

		this.$infiniteNextLink = null;
		this.$infiniteNextWrapper = null;
		this.$wrapper = null;

		this.debugEnabled_ = false;

		this.initialise_();
	};

	/**
	 * Init function
	 * @private
	 */
	UniversalPagination.prototype.initialise_ = function() {
		/**
		 * vytvoření wrapperu kolem aktuálního stránkování a uloží ho do this.$wrapper
		 */
		this.createWrapper_();
		/**
		 * inicializace správné lokalizace
		 */
		this.i18n = this.options.messages[this.options.lang];
		/**
		 * detekce podpory HTML5 history
		 * @type {History|*}
		 */
		this.historySupported = history && history.replaceState;

		/**
		 * načtení elementu seznamu
		 * @type {*|HTMLElement}
		 */
		this.$list = $(this.options.listSelector);

		/**
		 * vygenerování a zprovoznění infinite pagination
		 */
		if (this.options.infinitePagination) {
			this.applyInfinitePagination_();
		}

		/**
		 * aplikace ajaxu na číslované stránkování
		 */
		if (this.options.numberedPagination) {
			this.applyNumberedPagination_();
		}

		/**
		 * vygenerování unikátního ID pagination z DOM cesty
		 */
		this.uniqueId = this.getDomId_(this.$t);

		/**
		 * pokud je povoleno preloadování stránky z historie, provede se - načte se historie a zobrazí se poslední stránka, která byla navštívena
		 */
		if (this.options.autoPreloadHistory) {
			this.preloadHistoryStateIfAny();
		}
	};

	/**
	 * vytvoří a uloží wrapper kolem stránkování
	 * @private
	 */
	UniversalPagination.prototype.createWrapper_ = function() {
		// ugly way, stupid stupid stupid jQuery - can wrap only with 'HTML string', not with jQuery object
		this.$t.wrap('<div class="'+this.options.wrapperClass+'"></div>');
		this.$wrapper = this.$t.parent('.' + this.options.wrapperClass);
	};

	/**
	 * vytvoří button pro nekonečné načítání a zajistí jeho funkčnost
	 * @private
	 */
	UniversalPagination.prototype.applyInfinitePagination_ = function() {
		this.renderInfinitePaginationButton_(this.$wrapper);
		this.bindEventInfinitePaginationButton_();
	};

	/**
	 * načte z aktuálního stránkování button na další stránku a vytvoří z něj nekonečný button
	 * @private
	 */
	UniversalPagination.prototype.renderInfinitePaginationButton_ = function(htmlSet) {
		/**
		 * odstraní existující nekonečný button předtím, než vytvoří nový, aktualizovaný
		 */
		if (this.$infiniteNextWrapper instanceof $) {
			if (this.$infiniteNextLink) this.$infiniteNextLink.off();
			this.$infiniteNextWrapper.remove();
		}
		/**
		 * najde url na další stránku a vytvoří nekonečný button s wrapperem
		 */
		var $nextLink = $(htmlSet).find(this.options.nextPageButtonSelector);
		if ($nextLink.size() > 0) {
			this.$infiniteNextWrapper = $('<p class="'+this.options.nextWrapperClass+'"></p>').appendTo(this.$wrapper);
			this.$infiniteNextLink = $('<a data-page-number="'+$nextLink.data('pageNumber')+'" class="'+this.options.nextClass+'" href="'+$nextLink.attr('href')+'">'+this.i18n.next+'</a>').appendTo(this.$infiniteNextWrapper);
		}
	};

	/**
	 * ošetří ajaxový request na další stránku pro nekonečné stránkování
	 * @private
	 */
	UniversalPagination.prototype.bindEventInfinitePaginationButton_ = function() {
		var self_ = this;
		if (this.$infiniteNextLink) {
			this.$infiniteNextLink.on('click', function(event) {
				event.preventDefault();
				/**
				 * nahradí text "Více" za "Nahrává se"
				 */
				$(event.currentTarget).html(self_.i18n.loading);

				/**
				 * načte další stránku a naparsuje její obsah, poté reinicializuje stránkování
				 */

				/**
				 * vystreli event s cislem stranky jeste pred hitem na novou stranku
				 */
				var newPageNumber = parseInt($(event.currentTarget).data('pageNumber') || 1);
				self_.$t.trigger(self_.options.onBeforeNewPageLoad, [self_, newPageNumber, 'infinite']);

				/**
				 * request
				 */
				var url = $(event.currentTarget).attr('href');
				$.get(url, function(response) {
					self_.parseAndRenderResponse_(response, false, false, 'infinite', newPageNumber);
					self_.reinitPagination_(response, url, true);
				});
			});
		}
	};

	/**
	 * naparsování odpovědi další stránky
	 * @param response - samotná odpověď
	 * @param clearList - flag, zda má vymazat předchozí obsah (číslované stránkování) nebo ne (nekonečné načítání)
	 * @param scrollTo - flag, zda se bude scrollovat na začátek seznamu (číslované stránkování)
	 * @param type - typ odstránkování (infinite, number, history) - pouze pro potřeby externího ošetření eventy UP_AFTER_CONTENT_RENDERED
	 * @private
	 */
	UniversalPagination.prototype.parseAndRenderResponse_ = function(response, clearList, scrollTo, type, pageNumber) {
		/**
		 * najde všechny položky seznamu ve výsledku
		 */
		var $items = $(response).find(this.options.listSelector + ' ' + this.options.itemSelector);

		/**
		 * výmaz všech položek, pokud je to požadováno
		 */
		if (clearList) {
			this.$list.empty();
		}

		this.$t.trigger(this.options.onBeforePageContentRendered, [this, pageNumber, type]);

		/**
		 * přidání nových položek do seznamu
		 */
		this.$list.append($items);


		/**
		 * vystřelení eventy UP_AFTER_CONTENT_RENDERED po vykreslení seznamu
		 */
		this.$t.trigger(this.options.onAfterPagedContentRendered, [this, type]);

		/**
		 * provedení autoscrollu na první položku v případě, že je to požadováno (číslované stránkování)
		 */
		if (this.options.enableAutoscroll && scrollTo) {
			$('html, body').animate({ scrollTop: this.$list.offset().top - this.options.listTopOffset }, 200);
		}
	};

	/**
	 * najde nové stránkování v ajaxové response, nahradí to staré ve stránce a znovu se vygeneruje nekonečné stránkování
	 * @private
	 */
	UniversalPagination.prototype.reinitPagination_ = function(response, url, firePageChangedTrigger) {
		/**
		 * najde a nahraje nové stránkování
		 */
		var $newPagination = $(response).find(this.options.paginationSelector);
		this.$t.html($newPagination.html()); // can't use .replaceWith() due to this.$t reference

		/**
		 * pokud je požadováno, aplikuje se nekonečné načítání
		 */
		if (this.options.infinitePagination) {
			this.applyInfinitePagination_();
		}

		/**
		 * uložení stavu do historie k aktuálnímu záznamu
		 * @type {Object|{universalPagination: {}}}
		 */
		var state = history.state || {};
		state.universalPagination = {};

		state.universalPagination[this.uniqueId] = {
			url: url,
			pagination: this.options.paginationSelector
		};

		this.saveStateToHistory_(state);

		/**
		 * vystřelí se eventa - asi nejposlednější možnost, kdy vypálit eventu, že je hotovo
		 */
		if (firePageChangedTrigger) {
			this.$t.trigger(this.options.onAfterPageChanged, [this, state, this.uniqueId]);
		}
	};

	/**
	 * zajištění ajaxového nahrávání dalších stránek při použití číselného stránkování
	 * @private
	 */
	UniversalPagination.prototype.applyNumberedPagination_ = function() {
		var self_ = this;
		this.$t.on('click', 'a', function(event) {
			event.preventDefault();
			var url = $(event.currentTarget).attr('href');

			// vystreli event s cislem stranky jeste pred hitem na novou stranku
			var newPageNumber = parseInt($(event.currentTarget).data('pageNumber') || 1);
			self_.$t.trigger(self_.options.onBeforeNewPageLoad, [self_, newPageNumber, 'numbers']);

			$.get(url, function(response) {
				self_.parseAndRenderResponse_(response, true, true, 'numbers', newPageNumber);
				self_.reinitPagination_(response, url, true);
			});
		});
	};

	/**
	 * funkce zjistí cestu k elementu v DOMu (vč. className a ID) ve formátu CSS zápisu a vrátí hash.
	 * @param el
	 * @returns {string}
	 * @private
	 */
	UniversalPagination.prototype.getDomId_ = function(el) {
		var path = $(el).parents().addBack();
		var fullPath = path.get().map(function (item) {
			var self = $(item),
				id = item.id ? '#' + item.id : '',
				clss = item.classList.length ? item.classList.toString().split(' ').map(function (c) {
					return '.' + c;
				}).join('') : '',
				name = item.nodeName.toLowerCase();

			/**
			 * prozatím hardcoded hack, FG partialUpdate partialUpdateDynamicContainer class překáží,
			 * protože při načtení stránky neexistuje, po provedení partial update ano - mění tím cestu v DOMu k jednotlivým elementům
			 */
			if (clss.indexOf('partialUpdateDynamicContainer') > -1) {
				return '';
			}
			if (name === 'html' || name === 'body') {
				return name;
			}
			return name + id + clss;

		}).join(' > ');
		fullPath = fullPath.replace(/>  >/ig, '>');

		/**
		 * doplníme stringovou konstantu k hashi (hash je číselný), protože výsledek ukládáme do asociativního pole,
		 * kde pouze číselná hodnota působí problmy
		 */
		return 'h' + String(this.hashCode_(fullPath));
	};

	/**
	 * převedení stringu do 32bit integeru ("hash")
	 * @param str
	 * @returns {number}
	 * @private
	 */
	UniversalPagination.prototype.hashCode_ = function(str) {
		var hash = 0, i, chr, len;
		if (str.length == 0) return hash;
		for (i = 0, len = str.length; i < len; i++) {
			chr   = str.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	};

	/**
	 * uložení aktuálního stavu k aktuální položce v browser.history (replaceState)
	 * @param data
	 * @private
	 */
	UniversalPagination.prototype.saveStateToHistory_ = function(data) {
		if (this.historySupported) {
			history.replaceState(data, document.title, window.location.href);
		}
	};

	/**
	 * funkce zjistí, zda je něco uloženého u aktuální položky v browser.history a pokud ano, aplikuje stav stránkování
	 * @returns {boolean}
	 */
	UniversalPagination.prototype.preloadHistoryStateIfAny = function() {

		var itemProperties = null;
		if (!this.historySupported) {
			return false;
		}

		if (history && history.state && history.state.universalPagination) {
			/**
			 *  prolistujeme uložené stavy stránkování u záznamu v historii
			 */
			for (var item in history.state.universalPagination) {
				/**
				 * JS objekt defense
				 */
				if (!history.state.universalPagination.hasOwnProperty(item)) { return false; }

				/**
				 * uložení aktuálně procházeného stavu do proměnné
				 */
				itemProperties = history.state.universalPagination[item];

				/**
				 * pokud se identifikátor aktuálně procházeného stavu rovná ID aktuálního stránkování,
				 * nahrajeme a vyrenderujeme požadovanou stránku
				 */
				if (item == this.uniqueId) {
					this.loadAndRenderSpecifiedPage(itemProperties.url, 'history');
				}
			}
		}

		return true;
	};

	/**
	 * nahraje stránku z požadované url, rozparsuje ji, vyrenderuje a znovu inicializuje stránkování
	 * @param url
	 * @param type
	 */
	UniversalPagination.prototype.loadAndRenderSpecifiedPage = function(url, type) {
		var self_ = this;
		$.get(url, function(response) {
			self_.parseAndRenderResponse_(response, true, false, type);
			self_.reinitPagination_(response, url, false);
		});
	};

	/**
	 * debug funkce
	 * @private
	 */
	UniversalPagination.prototype.debug_ = function() {
		if (this.debugEnabled_) {
			console.log(arguments);
		}
	};

	/**
	 * getter for uniqueId of the instance
	 * @returns {*}
	 */
	UniversalPagination.prototype.getUniqueId = function() {
		return this.uniqueId;
	};

	var API = {
		preloadHistoryStateIfAny: UniversalPagination.prototype.preloadHistoryStateIfAny,
		loadAndRenderSpecifiedPage: UniversalPagination.prototype.loadAndRenderSpecifiedPage,
		getUniqueId: UniversalPagination.prototype.getUniqueId
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new UniversalPagination(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

})( jQuery, window, document );


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.universal-pagination.js